import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { currency } from 'utils/currency';
import { titleCase } from 'utils/strings';
import styles from './styles.module.scss';

const OrderHeader = ({
  isDesktop,
  saleType,
  items,
  orderTotal,
  shippingAddress,
  onClickHeader,
  toggleOpen,
}) => {
  const { firstName, lastName, address1, address2, city, state, zipCode } = shippingAddress;
  const shipToTooltip = `<p>${firstName} ${lastName}</p>
  <p>${titleCase(address1)} ${titleCase(address2) || ''}</p>
  <p>${titleCase(city)}, ${state} ${zipCode}</p>`;
  const icon = isDesktop ? 'fal fa-angle-down' : 'fal fa-angle-right';

  return (
    <>
      <div
        className={styles['collapsible-bar']}
        onClick={onClickHeader}
        onKeyPress={onClickHeader}
        role="menubar"
        tabIndex="0"
        data-testid="collapsible-bar-order-header-container"
      >
        <div className={styles['sale-type']}>
          <h3>Sale Type</h3>
          <p>{saleType}</p>
        </div>
        <div className={`${styles.header} ${styles['order-header']}`}>
          <div className={styles.details}>
            <div>
              <h3>Items</h3>
              <p>{items}</p>
            </div>
            <div className={styles.total}>
              <h3>Total</h3>
              <p>{currency.format(orderTotal)}</p>
            </div>
            <div>
              <h3>Ship To</h3>
              <p className={styles['ship-to']} data-tip={shipToTooltip} data-for="shipping">
                {`${firstName} ${lastName}`} <i className="fal fa-angle-down" />
              </p>
            </div>
          </div>
          <button
            className={styles.button}
            onClick={toggleOpen}
            type="button"
            data-testid="expand-collapse-btn"
          >
            <i className={icon} />
          </button>
        </div>
      </div>
      <ReactTooltip
        id="shipping"
        place="bottom"
        type="dark"
        effect="solid"
        className={styles.tooltip}
        html
      />
    </>
  );
};

OrderHeader.propTypes = {
  saleType: PropTypes.string.isRequired,
  items: PropTypes.number.isRequired,
  orderTotal: PropTypes.number.isRequired,
  shippingAddress: PropTypes.shape({}).isRequired,
  onClickHeader: PropTypes.func.isRequired,
  toggleOpen: PropTypes.func.isRequired,
};

export default OrderHeader;
